export const KINDLYCHAT_KEY = process.env.NEXT_PUBLIC_KINDLYCHAT_KEY

export const EVENTS: { [key: string]: string } = {
  'open-chatbubble': 'open_chat',
  'welcome-page-start-chat': 'start_chat',
}

export const MARKET_CONTEXT: { [key: string]: string } = {
  es: 'spain',
  pt: 'portugal',
}
